/**
 * Everything on the public site that is copy rather than code.
 * Edit this file to change contacts, districts or the agency blurb —
 * no need to touch the components.
 */

export const CONTACTS = {
  // Номери рієлторів — усі показуються на сайті (підвал, «Контакти», сторінка
  // квартири). label — як номер виглядає, href — лише цифри для дзвінка.
  phones: [
    { label: "+380 (68) 738-30-37", href: "+380687383037" },
    { label: "+380 (97) 239-67-02", href: "+380972396702" },
  ],
  email: "nataliariellvivw@gmail.com",
  address: "м. Львів, вул. Дорошенка, 1",
  hours: "Пн–Сб, 9:00 – 19:00",
  viber: "",
  telegram: "",
};

/** Districts of Lviv, used to seed the filter dropdown before data loads. */
export const LVIV_DISTRICTS = [
  "Галицький",
  "Залізничний",
  "Личаківський",
  "Сихівський",
  "Франківський",
  "Шевченківський",
];

export const HEATING_OPTIONS = ["Центральне", "Індивідуальне"];

/**
 * Частина об'єктів у базі має ціну в гривнях, частина — у доларах.
 * Кожне оголошення завжди показується у своїй валюті, але щоб порівнювати
 * їх між собою (фільтр «ціна від/до», сортування, «від N на місяць»),
 * усі суми зводяться до гривні за цими курсами.
 *
 * ОНОВЛЮЙТЕ ЦІ ЗНАЧЕННЯ час від часу — вони впливають лише на порядок
 * сортування та межі фільтра, тож приблизної точності достатньо.
 * Актуальний офіційний курс: https://bank.gov.ua/ua/markets/exchangerates
 */
export const BASE_CURRENCY = "UAH";

export const EXCHANGE_RATES = {
  UAH: 1,
  ГРН: 1,
  "ГРН.": 1,
  USD: 44,
  ДОЛАР: 44,
  $: 44,
  EUR: 51,
  ЄВРО: 51,
  "€": 51,
};

/**
 * Сезонне оформлення сайту і панелі рієлтора:
 *   "auto"        — за календарем: Хелловін увесь жовтень, Різдво з 1 грудня
 *                   до 14 січня, решту року звичайний вигляд;
 *   "halloween"   — хелловінська тема незалежно від дати;
 *   "christmas"   — різдвяна тема незалежно від дати;
 *   ""            — завжди звичайний вигляд.
 * Щоб подивитися будь-який варіант без викладки, додайте до адреси
 * ?season=halloween, ?season=christmas або ?season=off.
 */
export const SEASON = "auto";

export const SITE = {
  name: "LeoCity",
  tagline: "Оренда квартир у Львові",
  description:
    "Актуальна база квартир для оренди у Львові. Перевірені оголошення, " +
    "реальні фото та супровід рієлтора на кожному етапі.",
};
